import Swal from 'sweetalert2';

function alertSuccess(config: {title: string; text?: string; button: string}, callback: () => void): boolean {
  if (!config) return false;

  Swal.fire({
    title: config.title,
    text: config.text,
    icon: 'success',
    confirmButtonText: config.button || '确 定',
    showCancelButton: false,
    customClass: {
      confirmButton: 'el-button el-button--primary',
    },
    buttonsStyling: false,
  }).then(() => {
    if (callback) {
      callback();
    }
  });

  return false;
}

export default alertSuccess;
